import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ArrowRight, MapPin, Users, Award } from 'lucide-react';
import api from '../api/api';
import Hero from '../components/Hero';
import { motion } from 'framer-motion';
import LatestTours from '../components/LatestTours';
import CategoryFilter from '../components/CategoryFilter';
import SearchBar from '../components/SearchBar';
import FeaturedBlogs from './FeaturedBlogs ';
import ScrollingGallery from './ScrollingGallery';
import c1 from '../asset/c1.jpg'
import c2 from '../asset/c2.jpg'
import c3 from '../asset/c3.jpg'
import c4 from '../asset/c4.jpg'
import c5 from '../asset/c5.jpg'
import c6 from '../asset/c6.jpg'
import c7 from '../asset/c7.jpg'
import c8 from '../asset/c8.jpg'
import Testimonials from './Testimonials';
export default function Home() {
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
 const clinicImages = [
    {
      src: c1,
      alt: 'YS Sky Tour Travel',
   
    },
    {
      src: c2,
      alt: 'YS Sky Tour Travel',
    
    },
    {
      src: c3,
      alt: 'YS Sky Tour Travel',
   
    },
    {
      src: c4,
      alt: 'YS Sky Tour Travel',
   
    }, {
      src: c5,
      alt: 'YS Sky Tour Travel',
   
    },
     {
      src: c6,
      alt: 'YS Sky Tour Travel',
   
    },
     {
      src: c7,
      alt: 'YS Sky Tour Travel',
   
    },
     {
      src: c8,
      alt: 'YS Sky Tour Travel',
   
    },
  ];
  useEffect(() => {
    const fetchLatestTours = async () => {
      try {
        const res = await api.get('/tours/latest');
        setTours(res.data);
      } catch (error) {
        console.error('Error fetching tours:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLatestTours();
  }, []);

  return (
    <div className="bg-white dark:bg-slate-950 transition-colors duration-300">
       <Helmet>
        <title>YS Sky Travel and Tour Agency P.L.C — Explore Ethiopia & Beyond</title>
        <meta name="description" content="Discover tours, flights, hotels, and activities with YS Sky Travel and Tour Agency P.L.C. Find your next adventure today!" />
        <meta name="keywords" content="Ethiopia tours, Africa travel, adventure travel, hotels, flights, travel agency" />
      </Helmet>
      <Hero />

      {/* Search & Filter Section */}
     

      {/* Latest Tours Section */}
        { tours.length > 0 &&
   <section className="py-6">
  <div className="container">
    {/* Section Header */}
    <div className="flex flex-col md:flex-row items-center justify-between mb-12">
      <div>
        <h2 className="section-title text-4xl md:text-5xl font-bold">
          Latest <span className="text-green-600">Tours</span>
        </h2>
        <p className="section-subtitle mt-2 text-gray-600 dark:text-gray-400">
          Discover our newest and most exciting tour packages
        </p>
      </div>
      <Link
        to="/tours"
        className="hidden md:flex items-center gap-2 text-green-600 hover:text-green-700 font-semibold transition-colors mt-4 md:mt-0"
      >
        View All Tours
        <ArrowRight className="w-5 h-5 text-green-600" />
      </Link>
    </div>

    {/* Loader */}
 
      <>
        {/* Tours Grid */}
        <LatestTours tours={tours} highlightColor="green" />

        {/* Mobile "View All" */}
        <div className="md:hidden text-center mt-12">
          <Link
            to="/tours"
            className="btn-primary inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white"
          >
            View All Tours
            <ArrowRight className="w-5 h-5 text-white" />
          </Link>
        </div>
      </>
   
   
    
  </div>
</section>
 }
<FeaturedBlogs/>
     
      <section className="py-2 ">
        <div className="max-w-7xl mx-auto  sm:px-6 lg:px-8">
        
          <ScrollingGallery images={clinicImages} />
        </div>
      </section>
      <Testimonials/>
    </div>
  );
}
